"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatElapsed = exports.clear = exports.success = exports.fatal = exports.warnOnce = exports.warn = exports.print = exports.isInteractive = void 0;
const shared_log_1 = require("shared-log");
const checkInteractivity = require("is-interactive");
const k = require("kleur");
/**
 * Equals true when `process.stdout` is a TTY.
 *
 * When false, the `clear` and `spin` functions do nothing,
 * and `MistyTask` methods are restricted to append-only logs.
 */
exports.isInteractive = checkInteractivity();
/** Write to the current line */
exports.print = process.stdout.write.bind(process.stdout);
/**
 * Log a yellow message prefixed by `[!]`
 */
function warn(msg) {
    shared_log_1.emit('warn', [k.yellow('[!] ' + msg)], shared_log_1.callerPath());
}
exports.warn = warn;
const pastWarnings = new Set();
/** Print a warning at most once */
function warnOnce(msg) {
    if (!pastWarnings.has(msg)) {
        pastWarnings.add(msg);
        warn(msg);
    }
}
exports.warnOnce = warnOnce;
/**
 * Log an error message and call `process.exit(1)`
 */
function fatal(...args) {
    shared_log_1.emit('error', [k.red('[!]'), ...args], shared_log_1.callerPath());
    process.exit(1);
}
exports.fatal = fatal;
/**
 * Log a message prefixed by a green ✔︎
 */
function success(...args) {
    shared_log_1.emit('info', [k.green('✔︎'), ...args], shared_log_1.callerPath());
}
exports.success = success;
/** @internal */
function clear(lines) {
    if (!exports.isInteractive)
        return;
    if (lines == null) {
        exports.print('\x1B[2J\x1B[3J\x1B[H\x1Bc');
    }
    else {
        exports.print('\x1B[2K'); // clear line
        exports.print('\x1B[1000D'); // move to beginning of line
        while (0 < lines--) {
            exports.print('\x1B[1A'); // move up one line
            exports.print('\x1B[2K'); // clear line
        }
    }
}
exports.clear = clear;
/** Format an elapsed time (in milliseconds) to a human-readable string */
function formatElapsed(start) {
    const elapsedMs = Date.now() - start;
    return elapsedMs < 200
        ? elapsedMs + 'ms'
        : (elapsedMs / 1000).toFixed(1) + 's';
}
exports.formatElapsed = formatElapsed;
//# sourceMappingURL=index.js.map